if (!customElements.get("delivery-time")) {
  customElements.define(
    "delivery-time",
    class Pincode extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=pincode]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.deliveryTimeContainer = this.querySelector('[id="response1"]');
        this.deliverySubTimeContainer = this.querySelector(
          '[id="sub-response1"]'
        );
        this.deliveryTimeContainer1 = this.querySelector('[id="response2"]');
        this.deliveryTime = this.querySelector('[id="time1"]');
        this.deliverySubTime = this.querySelector('[id="sub-time1"]');
        this.deliveryTime2 = this.querySelector('[id="time2"]');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.deliveryTimeContainer1.style.display = "none";
        this.deliverySubTimeContainer.style.display = "none";
        const data = new FormData(this.form);
        const pincode = data.get("pincode");
        const isMto = document.querySelector(".mto_customize") && document.querySelector("#inv_quan").value < 1;
        if (pincode && pincode.toString().length === 6) {
          this.submitButton.setAttribute("aria-disabled", true);
          const sku = data.get("sku");
          this.submitButton.innerHTML = '<div class="loader"></div>';
          const url = `https://prod.giva-api.com/getDeliveryTime?${sku.includes("PR") ? "perfume=true&" : ""
            }pin=${pincode}&sku=${sku}${sku.includes("PX") ? "&isPersonalised=true" : ""
            }${isMto ? "&isMto=yes" : ""}`;
          fetch(url)
            .then((response) => response.json())
            .then((response) => {
              this.deliveryTime.innerHTML =
                response.message.split("or Buy")[0].split(". ")[0] + ".";
              this.deliverySubTime.innerHTML = response.message
                .split("or Buy")[0]
                .split(". ")[1];
              this.deliveryTime2.innerHTML =
                "Or buy" + response.message.split("or Buy")[1];
              if (response.message === "Delivery code unserviceable") {
                this.deliveryTime.style.color = "#C50000";
                this.deliveryTime.style.fontWeight = "600";
              } else {
                this.deliveryTime.style.color = "#000000";
                this.deliveryTime.style.fontWeight = "400";
              }
              if (response.message.split("or Buy")[1]) {
                this.deliveryTimeContainer1.style.display = "flex";
                this.deliverySubTimeContainer.style.display = "flex";
              }
            })
            .catch((err) => {
              console.log(err);
              this.deliveryTime.innerHTML =
                "<strong>Error occured in fetching the delivery time</strong>";
              this.deliveryTime.style.color = "#C50000";
            })
            .finally(() => {
              this.deliveryTimeContainer.style.display = "flex";
              this.submitButton.innerHTML = "<h4>Check</h4>";
            });
        } else {
          this.deliveryTime.innerHTML =
            "<strong>Please enter valid 6 digit pincode</strong>";
          this.deliveryTime.style.color = "#C50000";
        }
      }
    }
  );
}
